import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { CreateOutcomeStateService } from '../services/create-outcome-state.service';
import { OutcomeState } from '../types/outcome-state';

@Component({
    selector: 'app-outcome-details-custom-panel',
    templateUrl: './outcome-details-custom-panel.component.html',
    styleUrls: ['./outcome-details-custom-panel.component.scss'],
    standalone: false
})
export class OutcomeDetailsCustomPanelComponent implements OnInit {
    private createOutcomeStateService: CreateOutcomeStateService = inject(CreateOutcomeStateService);
    public outcomeState: OutcomeState;

    public ngOnInit(): void {
        this.outcomeState = this.createOutcomeStateService.outcomeState!;
    }
}
